import { render, staticRenderFns } from "./apiTable.vue?vue&type=template&id=0edf51fc&scoped=true&"
import script from "./apiTable.vue?vue&type=script&lang=js&"
export * from "./apiTable.vue?vue&type=script&lang=js&"
import style0 from "./apiTable.vue?vue&type=style&index=0&id=0edf51fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf51fc",
  null
  
)

export default component.exports